import theme from '../../../styles/theme.mjs';
import Container from '../../Basic/Container/Container.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import MediaCard from '../../UIElements/MediaCard/MediaCard.mjs';
import { StyledMediaCardImageContainer } from '../../UIElements/MediaCard/MediaCard.styles.mjs';
import SmallMediaCard from '../../UIElements/SmallMediaCard/SmallMediaCard.mjs';
import styled from 'styled-components';

const StyledOverlay = styled(FlexContainer) `
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 0 1rem;
  background: ${theme.colors.slate}E6;
  grid-area: 1 / 1;
  justify-self: center;
  align-self: center;
`;
const StyledContainer = styled.div `
  display: grid;
  aspect-ratio: 16 / 9;
`;
const ControlsContainer = styled(Container) `
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr;
  width: 100%;

  button {
    width: 100%;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    width: 300px;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xxl}) {
    width: 400px;
  }
`;
const StyledMediaCard = styled(MediaCard) `
  @media screen and (min-width: ${props => props.theme.breakpoints.xxl}) {
    max-width: 400px;

    ${StyledMediaCardImageContainer} {
      height: auto;
    }
  }
`;
const StyledSmallMediaCard = styled(SmallMediaCard) `
  flex-direction: row;
  width: 100%;
`;

export { ControlsContainer, StyledContainer, StyledMediaCard, StyledOverlay, StyledSmallMediaCard };
//# sourceMappingURL=VideoEndOverlay.styles.mjs.map
